import searchRedirectUrl from "./searchRedirectUrl";
import onlyOneProduct from "./onlyOneProduct";
import categoryPageNumberExceedsAvailableProducts from "./categoryPageNumberExceedsAvailableProducts";
import newInRedirect from "./newInRedirect";

const clientSideRedirect = async ({ response, state }) => {
  const rules = [
    searchRedirectUrl,
    onlyOneProduct,
    categoryPageNumberExceedsAvailableProducts,
    newInRedirect
  ];

  for (const rule of rules) {
    const result = rule({ response, state });

    const shouldRedirect = result instanceof Promise ? await result : result;

    if (shouldRedirect) {
      return true;
    }
  }

  return false;
};

export default clientSideRedirect;
